import { CoatStand } from '../parts/props'
import type { AssetContext, AssetDefinition } from '../types'

/**
 * Free-standing coat rack. Origin at the centre of the disc base, y = 0 on the
 * floor; the four hooks radiate at the top and carry the accent colour.
 */
function CoatStandItem({ accent, variant = 'chrome' }: AssetContext) {
  return <CoatStand tone={variant === 'dark' ? 'dark' : 'metalDark'} accent={accent} />
}

export const definition: AssetDefinition = {
  id: 'coat-stand',
  name: 'Perchero',
  category: 'decor',
  footprint: [0.36, 0.36],
  height: 1.72,
  accentable: true,
  variants: [
    { id: 'chrome', name: 'Cromado' },
    { id: 'dark', name: 'Grafito' },
  ],
  keywords: ['perchero', 'abrigos', 'colgador', 'coat stand', 'coat rack', 'hanger'],
  Component: CoatStandItem,
}
